import template from 'core/service/pdf-generation/products/whole-life/template'
import { createPdfDocument } from 'core/service/pdf-generation/document-creation'
import { createCommonPdf } from '../common/pdf-document'

import { getContentFullContent } from './content'

export const createFullBIDocDefinition = async (props) => {
  const pdfTemplate = await template({ ...props, biType: props.biType })
  return {
    content: await getContentFullContent(props),
    ...pdfTemplate,
  }
}

const createFullBIPdf = createPdfDocument(createFullBIDocDefinition)

export const createWholeLifePdf = async (props) => {
  return await createCommonPdf(props, createFullBIPdf)
}
